
















































































import {Component, Inject, Vue} from 'vue-property-decorator';
import {AngleWidget} from '@/views/dashboard/interfaces';
import WidgetBindDataSource from '@/components/widgets/base/WidgetBindDataSource.vue';
import Loading from '@c/controls/Loading.vue';
import {PModuleType} from '@/enums/configs';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {MeasurementType} from '@/views/system/measurements/enums';
import {getMeasurementById} from '@/utils/moduleUtils';
import {addAngleSubscription} from '@/utils/socketUtils';

@Component({
  components: {
    WidgetBindDataSource,
    Loading,
  },
})
export default class SpectrumHarmWidgetComponent extends Vue {
  //Данные виджета
  @Inject()
  widget!: AngleWidget;

  @Inject()
  measurements!: MeasurementData[];

  // Показатели загрузки и наличия ошибок
  loading = false;
  error = false;

  // Цвет заголовка
  colorCaption = '#e5e5e5';

  // предустановленный фильтр с типом ПМ для выбора источника данных виджета
  // TODO после тестирования оставить только подходящие типы ПМ для предустановленного фильтра
  presetFilter = [PModuleType.DtcpAccelerometerModule, PModuleType.DtcpEnergyModule];

  presetMeasurementFilter = [MeasurementType.Signal];

  pmodule: any | null = null;

  nodeId: string | null = null;

  moduleGUID = '';

  measurement!: MeasurementData;

  angles: any = [];

  amplitudes: any = [];

  angleValues: any = [];

  amplitudeValues: any = [];

  ids: any[] = [];

  caption: string | null = null;

  data = [
    {angle: 0, amplitude: 0},
    {angle: 0, amplitude: 0},
    {angle: 0, amplitude: 0},
  ];

  xMeasurements = [
    'angle_05_x',
    'angle_1_x',
    'angle_2_x',
    'amplitude_05_x',
    'amplitude_1_x',
    'amplitude_2_x',
  ];
  yMeasurements = [
    'angle_05_y',
    'angle_1_y',
    'angle_2_y',
    'amplitude_05_y',
    'amplitude_1_y',
    'amplitude_2_y',
  ];
  zMeasurements = [
    'angle_05_z',
    'angle_1_z',
    'angle_2_z',
    'amplitude_05_z',
    'amplitude_1_z',
    'amplitude_2_z',
  ];

  get firstLineStyle() {
    return this.angles[0] && this.amplitudes[0]
      ? {
          'transform': `rotate(${this.angles[0]}deg)`,
          'width': `${this.amplitudes[0]}%`,
        }
      : null;
  }

  get secondLineStyle() {
    return this.angles[1] && this.amplitudes[1]
      ? {
          'transform': `rotate(${this.angles[1]}deg)`,
          'width': `${this.amplitudes[1]}%`,
        }
      : null;
  }

  get thirdLineStyle() {
    return this.angles[2] && this.amplitudes[2]
      ? {
          'transform': `rotate(${this.angles[2]}deg)`,
          'width': `${this.amplitudes[2]}%`,
        }
      : null;
  }

  // Действия при выборе оси
  async onAxisSelect(data: any) {
    if (!data.pmodule || !data.nodeId) return;

    this.pmodule = data.pmodule;
    this.moduleGUID = data.pmodule.guid;
    this.widget.pmodule = data.pmodule;
    this.widget.nodeId = data.nodeId;
    this.widget.measurementId = data.measurementId;
    const measurement = getMeasurementById(this.measurements, data.measurementId);
    if (measurement) {
      this.measurement = measurement;
    }

    await this.defineInitialChartState(this.pmodule);
  }

  async created() {
    if (!this.widget.pmodule) return;
    this.nodeId = this.widget.nodeId;
    this.pmodule = this.widget.pmodule;
    if (this.widget.pmodule.guid) this.moduleGUID = this.widget.pmodule.guid;
    const measurement = getMeasurementById(this.measurements, this.widget.measurementId);
    if (measurement) {
      this.measurement = measurement;
    }

    await this.defineInitialChartState(this.widget.pmodule);
  }

  async defineInitialChartState(pmodule: any) {
    try {
      this.loading = true;
      this.error = false;

      const result = await this.apiStore.getLastEvents({
        id: pmodule.id,
        eventType: 'phase-angle-changed',
        limit: 1,
      });

      if (this.measurement.alias.includes('_x')) {
        this.caption = 'Оборотная для оси X';
        this.data = [
          {angle: result[0][0][1], amplitude: result[0][0][4]},
          {angle: result[0][0][7], amplitude: result[0][0][10]},
          {angle: result[0][0][13], amplitude: result[0][0][16]},
        ];
        this.setValues();
        this.addSubscription(0);
      }
      if (this.measurement.alias.includes('_y')) {
        this.caption = 'Оборотная для оси Y';
        this.data = [
          {angle: result[0][0][2], amplitude: result[0][0][5]},
          {angle: result[0][0][8], amplitude: result[0][0][11]},
          {angle: result[0][0][14], amplitude: result[0][0][17]},
        ];
        this.setValues();
        this.addSubscription(1);
      }
      if (this.measurement.alias.includes('_z')) {
        this.caption = 'Оборотная для оси Z';
        this.data = [
          {angle: result[0][0][3], amplitude: result[0][0][6]},
          {angle: result[0][0][9], amplitude: result[0][0][12]},
          {angle: result[0][0][15], amplitude: result[0][0][18]},
        ];
        this.setValues();
        this.addSubscription(2);
      }
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  setValues() {
    this.angles = [];
    this.amplitudes = [];
    this.angleValues = this.data.map(x => Math.round((x.angle * 180) / Math.PI));
    this.amplitudeValues = this.data.map(x => x.amplitude.toFixed(4));
    this.angleValues.forEach((x: any) => {
      this.angles.push(x + 90);
    });
    this.amplitudeValues.forEach((x: any) => {
      const val = (x / Math.max(...this.amplitudeValues)) * 50;
      this.amplitudes.push(Math.round(val));
    });
  }

  addSubscription(type: any) {
    if (!this.pmodule || !this.pmodule?.guid || !this.measurement) return;

    this.ids = [];
    if (type == 0)
      this.xMeasurements.forEach((m: any) => {
        const measurement = this.measurements.find(x => x.alias == m);
        this.ids.push(measurement?.id);
        this.addWSSubscriptions(measurement, type);
      });
    if (type == 1)
      this.yMeasurements.forEach((m: any) => {
        const measurement = this.measurements.find(x => x.alias == m);
        this.ids.push(measurement?.id);
        this.addWSSubscriptions(measurement, type);
      });
    if (type == 2)
      this.zMeasurements.forEach((m: any) => {
        const measurement = this.measurements.find(x => x.alias == m);
        this.ids.push(measurement?.id);
        this.addWSSubscriptions(measurement, type);
      });
  }

  addWSSubscriptions(measurement: any, type: any) {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }

    if (!this.pmodule) return;

    if (!this.$dataSocketManager.hasSubscription(measurement.id)) {
      const params = {
        moduleType: this.pmodule.type,
        moduleGUID: this.pmodule.guid,
        alias: measurement.alias,
        eventType: measurement.eventType,
      };
      const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;
      const subscriptionFunction = (socket: WebSocket) =>
        addAngleSubscription.call(this, socket, params);

      this.$dataSocketManager.addSubscription(
        measurement.id,
        subscrName,
        subscriptionFunction,
        type == 0
          ? this.onMessageX.bind(this)
          : type == 1
          ? this.onMessageY.bind(this)
          : this.onMessageZ.bind(this),
      );
    }
  }

  async onMessageX(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    if (!strParse) return;

    const data = strParse;

    try {
      this.error = false;

      switch (data.module_alias) {
        case 'angle_05_x':
          this.data[0].angle = data.value;
          this.setValues();
          break;
        case 'angle_1_x':
          this.data[1].angle = data.value;
          this.setValues();
          break;
        case 'angle_2_x':
          this.data[2].angle = data.value;
          this.setValues();
          break;
        case 'amplitude_05_x':
          this.data[0].amplitude = data.value;
          this.setValues();
          break;
        case 'amplitude_1_x':
          this.data[1].amplitude = data.value;
          this.setValues();
          break;
        case 'amplitude_2_x':
          this.data[2].amplitude = data.value;
          this.setValues();
          break;
      }
    } catch {
      this.error = true;
    }
  }

  async onMessageY(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    if (!strParse) return;

    const data = strParse;

    try {
      this.error = false;

      switch (data.module_alias) {
        case 'angle_05_y':
          this.data[0].angle = data.value;
          this.setValues();
          break;
        case 'angle_1_y':
          this.data[1].angle = data.value;
          this.setValues();
          break;
        case 'angle_2_y':
          this.data[2].angle = data.value;
          this.setValues();
          break;
        case 'amplitude_05_y':
          this.data[0].amplitude = data.value;
          this.setValues();
          break;
        case 'amplitude_1_y':
          this.data[1].amplitude = data.value;
          this.setValues();
          break;
        case 'amplitude_2_y':
          this.data[2].amplitude = data.value;
          this.setValues();
          break;
      }
    } catch {
      this.error = true;
    }
  }

  async onMessageZ(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    if (!strParse) return;

    const data = strParse;

    try {
      this.error = false;

      switch (data.module_alias) {
        case 'angle_05_z':
          this.data[0].angle = data.value;
          this.setValues();
          break;
        case 'angle_1_z':
          this.data[1].angle = data.value;
          this.setValues();
          break;
        case 'angle_2_z':
          this.data[2].angle = data.value;
          this.setValues();
          break;
        case 'amplitude_05_z':
          this.data[0].amplitude = data.value;
          this.setValues();
          break;
        case 'amplitude_1_z':
          this.data[1].amplitude = data.value;
          this.setValues();
          break;
        case 'amplitude_2_z':
          this.data[2].amplitude = data.value;
          this.setValues();
          break;
      }
    } catch {
      this.error = true;
    }
  }

  // Получить хранилище
  get apiStore() {
    return pmoduleStoresByTypeMap.get(this.widget.pmodule.type) as any;
  }

  beforeDestroy() {
    this.closeWS();
  }

  // Закрыть соединения веб сокетов
  closeWS() {
    if (this.$dataSocketManager)
      this.ids.forEach((id: any) => {
        this.$dataSocketManager.removeSubscription(id);
      });
  }
}
